<template>
  <div>
    <Profile />
    <Signature />
    <ChangePassword />
  </div>
</template>

<script>
import Profile from '@/views/profile/Profile';
import Signature from '@/views/profile/Signature';
import ChangePassword from '@/views/profile/ChangePassword';

export default {
    components: {
        Profile,
        Signature,
        ChangePassword,
    },
};
</script>
